export default __webpack_public_path__ + "static/media/management-comments-icon.80330027.svg";